export default {"src":"/_next/static/media/weatherunion-logo-light.979d0fed.svg","height":36,"width":199,"blurWidth":0,"blurHeight":0};